import React, { Component } from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import OfficeResults from "../../Helpers/OfficeResults";
import { loadPreviewMatches } from "../../../actions/matchmakingPreview";
import { requestState } from "../../../actions/utils";
import LoadingContent from "../../Helpers/LoadingContent";
import { translateProperties } from "../../../actions/signUpActions";
import { AppBar, Button, Divider, Grid, Container, Toolbar, Typography, Box, Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { RESIDENCE_TYPES } from "../../../constants";
import PropertyInformation from "../../User/Shared/Information/PropertyInformation";
import PropertyPics from "../../User/Shared/PropertyPics";

const propertyImages = [
    require("../../../images/png/office1.jpg"),
    require("../../../images/png/office2.jpg"),
    require("../../../images/png/office7.jpg"),
    require("../../../images/png/office5.jpg"),
    require("../../../images/png/office6.jpg"),
    require("../../../images/png/office3.jpg")
]

const ImageFromId = (id) => {
    if (!id) return propertyImages[0]
    const parsed = parseInt("1" + id.toString().replaceAll(/[^0-9]/g, ""))
    return propertyImages[parsed % propertyImages.length]
}

const translateResidenceType = (residenceType) => {
    if (!residenceType)
        return "-";
    let result = ""
    if (typeof residenceType === "string")
        result = [RESIDENCE_TYPES.find(item => item.value === residenceType)]
    if (Array.isArray(residenceType))
        result = residenceType
            .map(type => RESIDENCE_TYPES.find(item => item.value === type))
    result = result.map(type => type ? type.displayName : undefined)
        .filter(Boolean)
        .join(", ")
    return result;
}

const fallbackPosts = [
    {
        id: "fallback-1",
        title: "Kalevankatu 48, 00180 Helsinki",
        spaceType: " Office",
        price: " 799 € / kk",
        size: 86.5,
        displaySize: "86,5 m²",
        matchingPercentage: "66%",
        imageSrc: propertyImages[3],
        address: "Kalevankatu 48, 00180 Helsinki",
        residenceType: "office",
        rent: 799,
        description: "A nice office right in the heart of the city.",
        kitchen: true,
        wc: true,
        shower: false,
        breakRoom: true,
        parking: false
    },
    {
        id: "fallback-2",
        title: "Ruoholahdentori 6, 00180 Helsinki",
        spaceType: " Office",
        price: " 1499 € / kk",
        size: 230.5,
        displaySize: "230,5 m²",
        matchingPercentage: "45%",
        imageSrc: propertyImages[4],
        address: "Ruoholahdentori 6, 00180 Helsinki",
        residenceType: "office",
        rent: 1499,
        description: "Spacious office space with a beautiful view.",
        kitchen: true,
        wc: true,
        shower: true,
        breakRoom: true,
        parking: true
    },
    {
        id: "fallback-3",
        title: "Bulevardi 46, 00120 Helsinki",
        spaceType: " Office",
        price: " 699 € / kk",
        size: 30.5,
        displaySize: "30,5 m²",
        matchingPercentage: "70%",
        imageSrc: propertyImages[2],
        address: "Bulevardi 46, 00120 Helsinki",
        residenceType: "office",
        rent: 699,
        description: "Compact an practical office space.",
        kitchen: false,
        wc: true,
        shower: false,
        breakRoom: false,
        parking: false
    }
]
class ApartmentResultsFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDialogOpen: false,
            selectedMatch: null
        };
    }

    componentDidMount() {
        this.fetchMatches();
    }

    componentDidUpdate(prevProps) {
        // If form values that affect matchmaking change, we might want to refetch,
        // but for now, fetching on mount is usually sufficient when stepping forward in wizard.
        // Or we can compare prevProps.formValues with this.props.formValues here.
    }

    handleOpenDialog = (item) => {
        // We find the original match from previewMatches to pass full details
        // fallback items will just pass what they have.
        const originalMatch = (this.props.previewMatches && this.props.previewMatches.find(m => m.announcement && m.announcement.id === item.id)) || { announcement: { properties: item, residence: {} } };
        this.setState({
            isDialogOpen: true,
            selectedMatch: originalMatch
        });
    }

    handleCloseDialog = () => {
        this.setState({
            isDialogOpen: false,
            selectedMatch: null
        });
    }

    fetchMatches = () => {
        const { formValues, loadPreviewMatches } = this.props;
        if (formValues) {
            // Translate values just like we do before signup
            const translated = translateProperties(formValues);
            loadPreviewMatches(translated);
        }
    }

    render() {
        const { previewMatches, previewMatchesState } = this.props;

        if (previewMatchesState === requestState.inProgress) {
            return (
                <div style={{ padding: '2rem' }}>
                    <LoadingContent />
                    <Typography align="center" style={{ marginTop: '1rem' }}>
                        Finding the best properties for you...
                    </Typography>
                </div>
            )
        }

        let displayItems = previewMatches ? previewMatches.map(match => ({
            id: (match.announcement && match.announcement.id) || Math.random(),
            title: (match.announcement && match.announcement.properties && match.announcement.properties.address) || "Helsinki",
            spaceType: translateResidenceType(match.announcement && match.announcement.properties && match.announcement.properties.residenceType),
            price: (match.announcement && match.announcement.properties && match.announcement.properties.rent) ? `${match.announcement.properties.rent} € / kk` : "Ask for price",
            displaySize: (match.announcement && match.announcement.properties && match.announcement.properties.size) ? `${match.announcement.properties.size} m²` : "-",
            matchingPercentage: `${match.points}%`,
            imageSrc: ImageFromId(match.announcement && match.announcement.properties && match.announcement.properties.id)
        })) : [];

        // If we want it to be "similar it was before" we can limit to top 3 matches or at least 3
        displayItems = displayItems.slice(0, 3);

        if (displayItems.length < 3) {
            const needed = 3 - displayItems.length;
            displayItems = [...displayItems, ...fallbackPosts.slice(0, needed)];
        }

        return (
            <div>
                <Container maxWidth="lg" >
                    <Grid container spacing={4} style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                        {displayItems.map((item, index) => (
                            <OfficeResults key={item.id || index} item={item} onClick={this.handleOpenDialog} />
                        ))}
                    </Grid>
                    <Box display="flex" justifyContent="center" pt={4} pb={4}>
                        <Typography variant="h5" color="primary"> Enter continue to reach with the property owners</Typography>
                    </Box>
                </Container>

                <Dialog
                    open={this.state.isDialogOpen}
                    onClose={this.handleCloseDialog}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogContent>
                        {this.state.selectedMatch && this.state.selectedMatch.announcement && (
                            <React.Fragment>
                                <PropertyPics
                                    title={'Property Pictures'}
                                    residence={this.state.selectedMatch.announcement.residence}
                                />
                                <PropertyInformation
                                    listing
                                    title="Property information"
                                    properties={
                                        this.state.selectedMatch.announcement.properties
                                            ? {
                                                ...this.state.selectedMatch.announcement.properties,
                                                residenceType: (this.state.selectedMatch.announcement.residence && this.state.selectedMatch.announcement.residence.houseType) || this.state.selectedMatch.announcement.properties.residenceType
                                            }
                                            : {}
                                    }
                                />
                            </React.Fragment>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseDialog} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const selector = formValueSelector("signup");

export default connect(
    state => ({
        formValues: selector(state,
            "location", "address", "residenceType", "rentRange", "rent",
            "moveInDate", "sizeRange", "size", "moveOutDate",
            "kitchen", "waterTap", "wc", "shower", "breakRoom",
            "meetingRoom", "lounge", "lighting", "naturalLight",
            "driveIn", "controlRoom24h", "cameraSurveillance24h",
            "parking", "buildingInsurance", "smartLock"
        ), // Add any other property fields that affect matching
        previewMatches: state.user.previewMatches,
        previewMatchesState: state.user.previewMatchesState
    }),
    { loadPreviewMatches }
)(ApartmentResultsFields);

